import React from 'react';
import { get } from 'lodash';
import { Chip } from '@material-ui/core';

const TagList = ({ data, field, itemNamePath }) => {
  const list = get(data, field, []);

  return (
    <React.Fragment>
      {list.map((item, index) => {
        const itemLabel = get(item, itemNamePath);

        return (
          <Chip key={index} label={itemLabel} variant="outlined" size="small" />
        );
      })}
    </React.Fragment>
  );
};

export default TagList;
